module.exports = __webpack_public_path__ + "img/red_topImg.6baf09fd.png";